import * as z from "zod";

const envSchema = z.object({
  EXPO_PUBLIC_SUPABASE_URL: z.string(),
  EXPO_PUBLIC_SUPABASE_ANON_KEY: z.string(),
  EXPO_PUBLIC_REST_API_BASE_URL: z.string(),
  EXPO_PUBLIC_SYNC_API_URL: z.string(),
  NODE_ENV: z.string(),
  EXPO_PUBLIC_SENTRY_DSN: z.string().optional(),
});

// yup, anything thats not EXPO_PUBLIC_ _will_ be removed on client side
export const env: z.infer<typeof envSchema> = {
  EXPO_PUBLIC_SUPABASE_URL: process.env.EXPO_PUBLIC_SUPABASE_URL!,
  EXPO_PUBLIC_SUPABASE_ANON_KEY: process.env.EXPO_PUBLIC_SUPABASE_ANON_KEY!,
  EXPO_PUBLIC_REST_API_BASE_URL: process.env.EXPO_PUBLIC_REST_API_BASE_URL!,
  EXPO_PUBLIC_SYNC_API_URL: process.env.EXPO_PUBLIC_SYNC_API_URL!,
  // eslint-disable-next-line turbo/no-undeclared-env-vars
  EXPO_PUBLIC_SENTRY_DSN: process.env.EXPO_PUBLIC_SENTRY_DSN!,
  // eslint-disable-next-line turbo/no-undeclared-env-vars
  NODE_ENV: process.env.NODE_ENV!,
};
